import { render, staticRenderFns } from "./Flowersetting.vue?vue&type=template&id=54024316&scoped=true&"
import script from "./Flowersetting.vue?vue&type=script&lang=js&"
export * from "./Flowersetting.vue?vue&type=script&lang=js&"
import style0 from "./Flowersetting.vue?vue&type=style&index=0&id=54024316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54024316",
  null
  
)

/* custom blocks */
import block0 from "./Flowersetting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports